import graphQLAdapter from "@/adapters/graphQL.adapter.js";
import Notification from "@/entities/notification.entity.js";

/**
 * Notification Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.getNotifications = getNotifications.bind(this);
    this.notificationCreate = notificationCreate.bind(this);
    this.notificationRead = notificationRead.bind(this);
    this.getAddedNotificationSubscriber = getAddedNotificationSubscriber.bind(
      this
    );
  }
  /**
   * Get the list of notifications
   *
   * @static
   * @returns {Promise<Object|null>} Promise object represents the list of notifications
   */
  async list () {
    await this.adapter.init();
    const res = await this.getNotifications();
    return res.data.notifications.map(el => Notification.fromJson(el));
  }
  async create (option) {
    await this.adapter.init();
    return this.notificationCreate(option);
  }
  async read (option) {
    await this.adapter.init();
    return this.notificationRead(option);
  }
  async getSubscriber () {
    await this.adapter.init();
    return this.getAddedNotificationSubscriber();
  }
}

function getNotifications () {
  const query = `
    query {
      notifications {
        id
        title
        body
        isRead
        createdAt
      }
    }
  `;
  return this.adapter.query(query);
}
function notificationCreate (options = {}) {
  const mutation = `mutation ($title: String,$body: String){
    notificationCreate(notification: { title: $title, body: $body }) {
      id
      title
      body
      isRead
      createdAt
    }
  }
  `;
  return this.adapter.mutation(mutation, options);
}
function getAddedNotificationSubscriber () {
  const subscription = `subscription {
    addedNotification {
        id
        title
        body
        createdAt
      }
    }
    `;
  return this.adapter.subscription(subscription);
}
function notificationRead (options = {}) {
  const mutation = `mutation ($notificationId: ID!){
    notificationRead(notificationId: $notificationId) {
      id
      title
      body
      isRead
      createdAt
    }
  }
  `;
  return this.adapter.mutation(mutation, options);
}
